"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _LeftSideMenu = _interopRequireDefault(require("./LeftSideMenu.vue"));
var _RightSideMenu = _interopRequireDefault(require("./RightSideMenu.vue"));
var _BannerComponent = _interopRequireDefault(require("./formList/BannerComponent.vue"));
var _IconComponent = _interopRequireDefault(require("./formList/IconComponent.vue"));
var _NavigationComponent = _interopRequireDefault(require("./formList/NavigationComponent.vue"));
var _NoticeComponent = _interopRequireDefault(require("./formList/NoticeComponent.vue"));
var _ColorComponent = _interopRequireDefault(require("./formList/ColorComponent.vue"));
var _BackgroundComponent = _interopRequireDefault(require("./formList/BackgroundComponent.vue"));
var _DiamondComponent = _interopRequireDefault(require("./formList/DiamondComponent.vue"));
var _PlaceholderComponent = _interopRequireDefault(require("./formList/PlaceholderComponent.vue"));
var _BackgroundImageConfiguration = _interopRequireDefault(require("./formList/BackgroundImageConfiguration.vue"));
var _resourceNiche = _interopRequireDefault(require("./formList/resourceNiche.vue"));
var _PointsTabBar = _interopRequireDefault(require("./formList/PointsTabBar.vue"));
var _MenuCarouselmage = _interopRequireDefault(require("./formList/MenuCarouselmage.vue"));
var _PrimaryMenuConfiguration = _interopRequireDefault(require("./formList/PrimaryMenuConfiguration.vue"));
var _CommunityHCImage = _interopRequireDefault(require("./formList/CommunityHCImage.vue"));
var _CommunityHomepageIcon = _interopRequireDefault(require("./formList/CommunityHomepageIcon.vue"));
var _MembersDay = _interopRequireDefault(require("./formList/MembersDay.vue"));
var _CommunityBNavigationBar = _interopRequireDefault(require("./formList/CommunityBNavigationBar.vue"));
var _PointReward = _interopRequireDefault(require("./PreviewArea/PointReward.vue"));
var _OrderingBenefitsClub = _interopRequireDefault(require("./PreviewArea/OrderingBenefitsClub.vue"));
var _OrderingMenuHomepage = _interopRequireDefault(require("./PreviewArea/OrderingMenuHomepage.vue"));
var _PayFinish = _interopRequireDefault(require("./formList/PayFinish.vue"));
var _HomeSearch = _interopRequireDefault(require("./formList/HomeSearch.vue"));
var _HomeActivity = _interopRequireDefault(require("./formList/HomeActivity.vue"));
var _GroupDinnerComponent = _interopRequireDefault(require("./formList/GroupDinnerComponent.vue"));
var _StoredValuePopupConfiguration = _interopRequireDefault(require("./formList/StoredValuePopupConfiguration.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PageDecoration',
  components: {
    LeftSideMenu: _LeftSideMenu.default,
    RightSideMenu: _RightSideMenu.default,
    BannerComponent: _BannerComponent.default,
    IconComponent: _IconComponent.default,
    NavigationComponent: _NavigationComponent.default,
    NoticeComponent: _NoticeComponent.default,
    ColorComponent: _ColorComponent.default,
    BackgroundComponent: _BackgroundComponent.default,
    DiamondComponent: _DiamondComponent.default,
    PlaceholderComponent: _PlaceholderComponent.default,
    BackgroundImageConfiguration: _BackgroundImageConfiguration.default,
    ResourceNiche: _resourceNiche.default,
    PointsTabBar: _PointsTabBar.default,
    MenuCarouselmage: _MenuCarouselmage.default,
    PrimaryMenuConfiguration: _PrimaryMenuConfiguration.default,
    CommunityHCImage: _CommunityHCImage.default,
    CommunityHomepageIcon: _CommunityHomepageIcon.default,
    MembersDay: _MembersDay.default,
    CommunityBNavigationBar: _CommunityBNavigationBar.default,
    PointReward: _PointReward.default,
    OrderingBenefitsClub: _OrderingBenefitsClub.default,
    OrderingMenuHomepage: _OrderingMenuHomepage.default,
    PayFinish: _PayFinish.default,
    HomeSearch: _HomeSearch.default,
    HomeActivity: _HomeActivity.default,
    GroupDinnerComponent: _GroupDinnerComponent.default,
    StoredValuePopupConfiguration: _StoredValuePopupConfiguration.default
  },
  props: {
    // 属性定义
  },
  data: function data() {
    return {
      xcxType: '',
      selectedKey: 'home',
      selectedRightKey: '1-1',
      PreviewAreaConfig: {
        'home': {
          views: 'PointReward',
          title: '小程序首页'
        },
        'welfare': {
          views: 'PointReward',
          title: '福利社'
        },
        'pointsMall': {
          views: 'PointReward',
          title: '积分商城'
        },
        'recharge': {
          views: 'PointReward',
          title: '充值页'
        },
        'menu': {
          views: 'PointReward',
          title: '菜单页'
        },
        'cart': {
          views: 'PointReward',
          title: '购物车'
        },
        // 'checkout': { views: 'PointReward', title: '结算页' },
        'paymentDone': {
          views: 'PointReward',
          title: '支付完成页'
        },
        'orderPay': {
          views: 'PointReward',
          title: '订单支付页'
        },
        'orderDetail': {
          views: 'PointReward',
          title: '订单详情页'
        },
        'communityHome': {
          views: 'PointReward',
          title: '社区首页'
        },
        // 'communityDay': { views: 'PointReward', title: '社区会员日' },
        'communityCenter': {
          views: 'PointReward',
          title: '社区个人中心'
        },
        'tablePredetermine': {
          views: 'PointReward',
          title: 'table预定页'
        },
        'groupOrder': {
          views: 'PointReward',
          title: '团餐配置'
        }
      },
      componentConfig: {
        '1-1': {
          formList: 'BannerComponent',
          title: '轮播图配置',
          xcxType: 'GAGAX'
        },
        '1-2': {
          formList: 'IconComponent',
          title: '点餐Icon配置',
          xcxType: 'GAGAX'
        },
        '1-3': {
          formList: 'NavigationComponent',
          title: '底部导航栏配置',
          xcxType: 'GAGAX'
        },
        '1-4': {
          formList: 'NoticeComponent',
          title: '首页公告配置',
          xcxType: 'GAGAX'
        },
        '1-5': {
          formList: 'ColorComponent',
          title: '底部颜色配置',
          xcxType: 'GAGAX'
        },
        '1-6': {
          formList: 'BackgroundComponent',
          title: '背景颜色配置',
          xcxType: 'GAGAX'
        },
        '1-7': {
          formList: 'DiamondComponent',
          title: '金刚区配置',
          xcxType: 'GAGAX'
        },
        '2-1': {
          formList: 'BackgroundImageConfiguration',
          title: '背景图配置',
          xcxType: 'GAGAX'
        },
        '3-1': {
          formList: 'ResourceNiche',
          title: '资源位配置',
          xcxType: 'GAGAX'
        },
        '3-2': {
          formList: 'PointsTabBar',
          title: 'Tab栏配置',
          xcxType: 'GAGAX'
        },
        '3-3': {
          formList: 'PlaceholderComponent',
          title: '积分商城背景图',
          xcxType: 'GAGAX'
        },
        '4-1': {
          formList: 'PlaceholderComponent',
          title: '充值页配置',
          xcxType: 'GAGAX'
        },
        '4-2': {
          formList: 'PlaceholderComponent',
          title: '充值完成页配置',
          xcxType: 'GAGAX'
        },
        '5-1': {
          formList: 'MenuCarouselmage',
          title: '轮播图配置',
          xcxType: 'GAGAX'
        },
        // '5-2': { formList: 'PrimaryMenuConfiguration', title: '一级菜单配置' , xcxType:'GAGAX'},
        '6-1': {
          formList: 'PlaceholderComponent',
          title: '购物车图标',
          xcxType: 'GAGAX'
        },
        // '7-1': { formList: 'PlaceholderComponent', title: '结算页背景图' , xcxType:'GAGAX'},
        '8-1': {
          formList: 'PlaceholderComponent',
          title: '支付完成页背景图',
          xcxType: 'GAGAX'
        },
        '8-2': {
          formList: 'PayFinish',
          title: '支付完成页banner',
          xcxType: 'GAGAX'
        },
        '9-1': {
          formList: 'PlaceholderComponent',
          title: '订单详情页配置',
          xcxType: 'GAGAX'
        },
        '10-1': {
          formList: 'CommunityHCImage',
          title: '轮播图配置',
          xcxType: ''
        },
        '10-2': {
          formList: 'CommunityHomepageIcon',
          title: '底部导航栏配置',
          xcxType: ''
        },
        '10-3': {
          formList: 'HomeSearch',
          title: '首页-探索配置',
          xcxType: ''
        },
        '10-4': {
          formList: 'HomeActivity',
          title: '首页-活动配置',
          xcxType: ''
        },
        // '11-1': { formList: 'MembersDay', title: '会员日配置' , xcxType:''},
        '12-1': {
          formList: 'CommunityBNavigationBar',
          title: '底部轮播图配置',
          xcxType: ''
        },
        '13-1': {
          formList: 'PlaceholderComponent',
          title: '背景图',
          xcxType: ''
        },
        '13-2': {
          formList: 'PlaceholderComponent',
          title: '确认按钮配置',
          xcxType: ''
        },
        '14-1': {
          formList: 'GroupDinnerComponent',
          title: '团餐规则',
          xcxType: 'GAGAX'
        },
        '14-2': {
          formList: 'PlaceholderComponent',
          title: '团餐订单详情页图片',
          xcxType: 'GAGAX'
        },
        '14-3': {
          formList: 'PlaceholderComponent',
          title: '团餐落地页图片',
          xcxType: 'GAGAX'
        },
        '15-1': {
          formList: 'StoredValuePopupConfiguration',
          title: '储值弹窗配置',
          xcxType: 'GAGAX'
        }
      }
    };
  },
  computed: {
    PreviewArea: function PreviewArea() {
      var config = this.PreviewAreaConfig[this.selectedKey]; // 修正：使用 PreviewAreaConfig
      return config ? config.views : null;
    },
    currentComponent: function currentComponent() {
      var config = this.componentConfig[this.selectedRightKey];
      return config ? config.formList : null;
    },
    currentComponentTitle: function currentComponentTitle() {
      var config = this.componentConfig[this.selectedRightKey];
      return config ? config.title : '装修配置';
    }
  },
  methods: {
    handleSelect: function handleSelect(item) {
      // 目前仅记录所选分类键值
      this.selectedKey = item.key;
      // 自动选中对应分类的第一个右侧选项
      this.selectFirstRightOption(item.key);
    },
    selectFirstRightOption: function selectFirstRightOption(leftKey) {
      // 根据左侧菜单键值获取对应的第一个右侧选项
      var rightMenuConfig = {
        'home': '1-1',
        'welfare': '2-1',
        'pointsMall': '3-1',
        'recharge': '4-1',
        'menu': '5-1',
        'cart': '6-1',
        'checkout': '7-1',
        'paymentDone': '8-1',
        'orderPay': '15-1',
        'orderDetail': '9-1',
        'communityHome': '10-1',
        'communityDay': '11-1',
        'communityCenter': '12-1',
        'tablePredetermine': '13-1'
      };
      this.selectedRightKey = rightMenuConfig[leftKey] || '';
    },
    handleRightSelect: function handleRightSelect(item) {
      // 处理右侧菜单选择
      this.selectedRightKey = item.key;
      var config = this.componentConfig[this.selectedRightKey];
      this.xcxType = config && config.xcxType || '';
    }
  },
  mounted: function mounted() {
    // 页面加载时自动选中第一个左侧菜单项对应的第一个右侧选项
    this.selectFirstRightOption(this.selectedKey);
  }
};